import React, { createContext, useContext, useState } from 'react';
import { getLanguages } from '../actions/getLanguages'; // Assuming getLanguages is accessible here

// Create LivContext
export const LivContext = createContext();

// Provider component
export const LivProvider = ({ children }) => {
  const [isMuted, setIsMuted] = useState(true);
  const [currentlyPlayingUrl, setCurrentlyPlayingUrl] = useState(null);

  // Add language state - initialize with the first language
  const [languages, setLanguages] = useState(getLanguages()); // Get languages once
  const [language, setLanguage] = useState(languages[0]?.value || null); // Default to first language value or null

  const [user, setUser] = useState(null); // Assuming you might want to manage user state

  const [askId, setAskId] = useState(null);

  return (
    <LivContext.Provider
      value={{
        isMuted,
        setIsMuted,
        currentlyPlayingUrl,
        setCurrentlyPlayingUrl,
        language, // Provide language state
        setLanguage, // Provide language setter
        askId,
        setAskId,
        languages, // Optionally provide the list of languages if needed elsewhere
        setLanguages,
        user,
        setUser,
      }}
    >
      {children}
    </LivContext.Provider>
  );
};

// Custom hook to use LivContext
export const useLiv = () => {
  const context = useContext(LivContext);
  if (!context) {
    throw new Error('useLiv must be used within a LivProvider');
  }
  return context;
};
